import { isMobile } from '../utils/is-mobile';

const smoothScroll = () => {
  $('.js-scroll').on('click', function () {
    const hash = $(this).attr('href') || $(this).data('href');
    const section = hash.split('#')[1];
    let offset = 0;

    $('img').each(function (index, elm) {
      const img = $(elm);

      if (img.data('src') !== '') {
        img.attr('src', img.data('src'));
      }
    });

    if (!hash) {
      return;
    }

    if ($(this).parents('#navbar-header').length) {
      $('#navbar-header').slideUp();
    }

    if (section && $('#' + section).length) {
      offset = $('#' + section).offset().top;
    }

    if (isMobile()) {
      offset -= ($('.site-header .navbar').innerHeight() || 0);
    }

    setTimeout(function () {
      $('html, body').animate({
        scrollTop: offset
      },
        500,
        'swing',
      );
    }, 1000, 'easy-in-out');

    if (!$(this).data('href')) {
      return false;
    }
  });
};

export default smoothScroll;
